<template>
    <div>
        <div class="send">
            <div class="send__holder">
                <textarea
                    @keyup="resizeHandler($event)" 
                    v-model="noteText" 
                    class="send__area" 
                    :style="{ height: currentHeight + 'px' }" 
                    rows="2" 
                    placeholder="Написать заметку ..." 
                />
                <button @click="addNote" title="Сохранить" class="send__btn">
                    <i class="uk-icon-send"></i>
                </button>
            </div>
            <p class="send__message">
                * Вы видите только собственные заметки с ваших учетных записей. Они не видны сторонним пользователям.
            </p>
        </div>
        <div class="target" ref="target"></div>
    </div>
</template>

<script>
export default {
    data: () => ({
        noteText: '',
        minHeight: 40,
        maxHeight: 100,
        currentHeight: 40,
        currentTargetHeight: 0
    }),
    methods: {
        addNote() {
            this.$store.dispatch('card/notes/addNote', `<pre>${this.noteText}</pre>`)
            this.noteText = ''
            this.currentHeight = this.minHeight
        },
        resizeHandler(e) {
            const obj = e.target
            const target = this.$refs.target

            target.innerHTML = this.noteText
            this.currentTargetHeight = target.offsetHeight

            if(e.keyCode === 13) {
                this.currentHeight += 20
            } else {
                this.currentHeight = this.currentTargetHeight ? this.currentTargetHeight : this.minHeight
            }  

            if(this.currentHeight < this.minHeight)
                this.currentHeight = this.minHeight

            if(this.currentHeight > this.maxHeight)
                this.currentHeight = this.maxHeight
            
            $('#tiles').trigger('resize')

        }
    }
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables'

.target
    max-width: 417px
    position: absolute
    top: -100vh
    left: -100vw
    word-wrap: break-word
.send
    box-shadow: 0px -1px 2px 0px #00000061
    background: #f3f3f3
    padding: 10px
    position: relative
    z-index: 2
    &__holder
        width: 100%
        margin-bottom: 10px
        @include flex-between
    &__area
        resize: none
        width: calc(100% - 46px)
        padding: 10px
        border: 1px solid #87878747
        border-radius: 10px
        font-family: Arial
        font-size: 13px
        vertical-align: bottom
        margin: 0
        @include lic-scroll
        &::-webkit-scrollbar-thumb 
            background: none
        &::-webkit-scrollbar-thumb
            background: none
    &__btn
        border: none
        background: none
        cursor: pointer
        font-size: 30px
        &:hover
            color: #0a5396
    &__message
        margin: 0
        max-width: 425px
        padding: 0 10px
        color: #959595
        font-size: 13px
        font-style: italic
</style>